/* eslint-disable object-shorthand */

import {
    deleteAssetTagViaAPI,
    fetchAdminTagsFromAPI,
    putAgreedToListViaAPI,
    putAssetImageFlagViaAPI,
    putAssetTagViaAPI,
    putRoomVerticalViaAPI,
    updateTagRankingViaAPI
} from '../methods';

import fetchActions from './fetchActions.js';

const adminActions = {
    addAssetTag: (assetId, tagId) => {
        return (dispatch, getState) => {
            dispatch(adminActions.startAddAssetTagRequest());
            const { config } = getState();
            return putAssetTagViaAPI(config, assetId, tagId)
                .then(tag => {
                    dispatch(adminActions.addAssetTagSuccess(tag));
                })
                .catch(error => {
                    dispatch(adminActions.addAssetTagFailure(error));
                });
        };
    },
    updateTagRanking: function (assetId, tagId, tagRanking) {
        return (dispatch, getState) => {
            const { config } = getState();
            return updateTagRankingViaAPI(config, assetId, tagId, tagRanking)
                .then(() => dispatch(this.receiveUpdatedTagRanking(tagRanking)))
                .catch(console.log);
        };
    },
    receiveUpdatedTagRanking: tagRanking => ({
        type: 'UPDATE_TAG_RATING',
        payload: {
            tagRanking
        }
    }),
    setAdminModeAndSearch: (apiUrl, userLang, location, tag, params, trackingCookieId, rawAdminModeId) => {
        return dispatch => {
            const adminModeId = Number(rawAdminModeId);
            dispatch(adminActions.setAdminMode(adminModeId));
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId));
        };
    },
    setAdminMode: (modeId) => ({
        type: 'SET_ADMIN_MODE',
        payload: {
            modeId
        }
    }),
    startAddAssetTagRequest: () => ({
        type: 'START_ADD_ASSET_TAG_REQUEST'
    }),
    addAssetTagSuccess: tag => ({
        type: 'ADD_ASSET_TAG_SUCCESS',
        payload: {
            tag
        }
    }),
    addAssetTagFailure: error => ({
        type: 'ADD_ASSET_TAG_FAILURE',
        payload: {
            error
        }
    }),
    removeAssetTag: (assetId, tagId) => {
        return (dispatch, getState) => {
            dispatch(adminActions.startDeleteAssetTagRequest());
            const { config } = getState();
            return deleteAssetTagViaAPI(config, assetId, tagId)
                .then(removedTagId => {
                    dispatch(adminActions.deleteAssetTagSuccess(removedTagId));
                })
                .catch(error => {
                    dispatch(adminActions.deleteAssetTagFailure(error));
                });
        };
    },
    startDeleteAssetTagRequest: () => ({
        type: 'START_DELETE_ASSET_TAG_REQUEST'
    }),
    deleteAssetTagSuccess: tagId => ({
        type: 'DELETE_ASSET_TAG_SUCCESS',
        payload: {
            tagId
        }
    }),
    deleteAssetTagFailure: error => ({
        type: 'DELETE_ASSET_TAG_FAILURE',
        payload: {
            error
        }
    }),
    toggleAgreedToList: function (venueId, agreedToList) {
        return (dispatch, getState) => {
            dispatch(this.startAgreedToListRequest());
            const { config } = getState();
            return putAgreedToListViaAPI(config, venueId, agreedToList)
                .then(() => {
                    dispatch(adminActions.toggleAgreedToListSuccess(venueId, agreedToList));
                })
                .catch(error => {
                    dispatch(adminActions.toggleAgreedToListFailure(error));
                });
        };
    },
    startAgreedToListRequest: () => ({
        type: 'START_AGREED_TO_LIST_REQUEST'
    }),
    toggleAgreedToListSuccess: (venueId, agreedToList) => ({
        type: 'TOGGLE_AGREED_TO_LIST_SUCCESS',
        payload: {
            venueId,
            agreedToList
        }
    }),
    toggleAgreedToListFailure: error => ({
        type: 'TOGGLE_AGREED_TO_LIST_FAILURE',
        payload: {
            error
        }
    }),
    toggleAssetImageFlag: (config, assetId, imageId, flagged) => {
        return dispatch => {
            dispatch(adminActions.startToggleAssetImageFlagRequest());
            return putAssetImageFlagViaAPI(config, imageId, flagged)
                .then(() => {
                    dispatch(adminActions.toggleAssetImageFlagSuccess(assetId, imageId, flagged));
                })
                .catch(error => {
                    dispatch(adminActions.toggleAssetImageFlagFailure(error));
                });
        };
    },
    startToggleAssetImageFlagRequest: () => ({
        type: 'START_TOGGLE_ASSET_IMAGE_FLAG_REQUEST'
    }),
    toggleAssetImageFlagSuccess: (assetId, imageId, flagged) => ({
        type: 'TOGGLE_ASSET_IMAGE_FLAG_SUCCESS',
        payload: {
            assetId,
            flagged,
            imageId
        }
    }),
    toggleAssetImageFlagFailure: error => ({
        type: 'TOGGLE_ASSET_IMAGE_FLAG_FAILURE',
        payload: {
            error
        }
    }),
    fetchAdminTags: config => {
        return dispatch => {
            dispatch(adminActions.requestAdminTags());
            return fetchAdminTagsFromAPI(config)
                .then(adminTags => {
                    dispatch(adminActions.receiveAdminTagsSuccess(adminTags));
                })
                .catch(error => {
                    dispatch(adminActions.receiveAdminTagsFailure(error));
                });
        };
    },
    requestAdminTags: () => ({
        type: 'REQUEST_ADMIN_TAGS'
    }),
    receiveAdminTagsSuccess: adminTags => ({
        type: 'RECEIVE_ADMIN_TAGS_SUCCESS',
        payload: {
            adminTags
        }
    }),
    receiveAdminTagsFailure: error => ({
        type: 'RECEIVE_ADMIN_TAGS_FAILURE',
        payload: {
            error
        }
    }),
    updateRoomVerticalChange: (assetId, verticalId) => {
        return (dispatch, getState) => {
            dispatch(adminActions.startAddRemoveRoomVerticalChangeRequest());
            const { config } = getState();
            return putRoomVerticalViaAPI(config, assetId, verticalId)
                .then(() => {
                    dispatch(adminActions.AddRemoveRoomVerticalChangeSuccess());
                })
                .catch(error => {
                    dispatch(adminActions.AddRemoveRoomVerticalChangeFailure(error));
                });
        };
    },
    startAddRemoveRoomVerticalChangeRequest: () => ({
        type: 'START_ADD_REMOVE_ROOM_VERTICAL_CHANGE_REQUEST'
    }),
    AddRemoveRoomVerticalChangeSuccess: () => ({
        type: 'ADD_REMOVE_ROOM_VERTICAL_CHANGE_SUCCESS'
    }),
    AddRemoveRoomVerticalChangeFailure: error => ({
        type: 'ADD_REMOVE_ROOM_VERTICAL_CHANGE_FAILURE',
        payload: {
            error
        }
    })
};

export default adminActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/adminActions.js